
























































































































































































































import CFMDialog from "@/scripts/CFMDialog";
import { Component, Prop, Vue } from "vue-property-decorator";

import * as blockui from "@/helpers/block-ui";
import * as swal from "@/helpers/swal";
import * as dateFormat from '@/helpers/dateFormat';
import { confirmFreezeConflicts } from '@/helpers/freeze';
import { autoAssignShiftAvailable, initialSelection, isShiftMismatch, Position, positionId, ShiftAvailability, toUserPools } from '@/helpers/shiftAutoAssign';
import { canRemoveLastMaster, restoreWorkedUsers } from '@/scripts/services/workOrderStatusPolicy';
import { groupByRole } from '@/scripts/global/util';

import { mixinz } from "@/scripts/global/mixinz";
import { MultiSelectComponent } from "@syncfusion/ej2-vue-dropdowns"; //import { MultiSelectComponent, CheckBoxSelection } from "@syncfusion/ej2-vue-dropdowns";
import Multiselect from 'vue-multiselect'
import MinutePicker from '@/components/shared/minutepicker.vue';
import BootstrapSwitchComponent from '@/components/shared/BootstrapSwitchComponent';
import { CFMDTOWorkOrder, CFMModelWorkWithBreadCrumbView, CFMCoreContractListComboSource, CFMCoreEntityComboSource, CFMDTOMaintenancePlan, CFMDTOMaintenancePlanUpdate, CFMDTOWorkForMaintenancePlan, CFMDTOContract } from '@/scripts/services/ClientApiAuto'

@Component<MaintenancePlanTransformToWorkOrderDialog>({
  data() {
    return {};
  },

  methods: {},

  components: {
    "ejs-multiselect": MultiSelectComponent,
    'vue-multiselect': Multiselect,
    'minutepicker': MinutePicker,
    'bootstrap-switch-component': BootstrapSwitchComponent,
  },

  /*
  provide: {
    'multiselect': [CheckBoxSelection]
  },
  */

  validations() {
    return {};
  },

  mixins: [mixinz],
})
export default class MaintenancePlanTransformToWorkOrderDialog extends CFMDialog {
  @Prop()
  selectedMaintenancePlans?: Array<CFMDTOMaintenancePlan>;

  activeTab = {Id:0};
  startDate: null | Date = null;
  maintenancePlan: CFMDTOWorkOrder = {Name: '', Duration: 0, DeviceId: null};
  maintenanceTypeList : CFMCoreEntityComboSource[] = [];
  updateGetResponse: any = {};
  contract: CFMCoreContractListComboSource | null = null;
  contractList : CFMCoreContractListComboSource[] = [];
  sendMail=false;
  vendorList : {Name:string, Id:number}[] = [];

  userFields = { groupBy: "Role", text: "UserDisplayText", value: "Id" };
  observerUserFields = { groupBy: "Role", text: "ObserverUserDisplayText", value: "Id" };

  userDataPlaceHolder = "İşi Yapacak Personel Seçiniz";
  observerUserDataPlaceHolder = "Refakatçi Personel Seçiniz";
  /*
  multiMode = 'CheckBox';
  filterPlaceholder = 'Search vegetables';
  showSelectAll = true;
  showDropDownIcon = true;
  enableSelectionOrder = false;
  enableGroupCheck = true;
  popupHeight = "250px";
  */

  // Is emri basina: secilebilecekler (o is emrinin kendi uygun personel listesi) ve secim.
  // KAYDET her is emrine kendi secimini yazar.
  pools: Record<number, Record<Position, any[]>> = {};
  selections: Record<number, Record<Position, any[]>> = {};
  // Otomatik atamanin is emri basina vardiyada buldugu kisiler (kayittaki vardiya uyarisi icin).
  availability: Record<number, ShiftAvailability> = {};
  autoAssigning = false;

  loading = false;

  get workOrders(): any[] {
    return this.updateGetResponse.WorkOrders ? this.updateGetResponse.WorkOrders.map((x: any) => x.WorkOder) : [];
  }

  get userDataForSelect() {
    const pool = this.pools[this.activeTab.Id];
    return pool ? groupByRole(pool.master) : [];
  }

  get observerUserDataForSelect() {
    const pool = this.pools[this.activeTab.Id];
    return pool ? groupByRole(pool.observer) : [];
  }

  get selectedForMasterUser() {
    const selection = this.selections[this.activeTab.Id];
    return selection ? selection.master : [];
  }
  set selectedForMasterUser(value: any[]) {
    this.setSelection('master', value);
  }

  get selectedForObserverUser() {
    const selection = this.selections[this.activeTab.Id];
    return selection ? selection.observer : [];
  }
  set selectedForObserverUser(value: any[]) {
    this.setSelection('observer', value);
  }

  /**
   * Kayitta calismis personel atamadan cikarilamaz; grup secimi ve "tumunu temizle" de
   * dusurebildigi icin dusen calismis kullanici geri konur. Sunucu ayrica zorluyor.
   */
  setSelection(position: Position, value: any[]) {
    const selection = this.selections[this.activeTab.Id];
    if (!selection) return;
    const restored = restoreWorkedUsers(value, selection[position]);
    if (restored) toastr.error(this.translate("worked_staff_cannot_be_removed"));
    selection[position] = restored || value;
  }

  /** Calismis personel setSelection'da geri konur; burada yalnizca son sorumlu kurali. */
  removeForMasterUser(user: any) {
    if (this.selectedForMasterUser.length === 1 && !canRemoveLastMaster(this.maintenancePlan.OrderStatusId)) {
      toastr.error(this.translate("cannot_personnel_appointed"));
      return;
    }
    this.selectedForMasterUser = this.selectedForMasterUser.filter((x: any) => x.Id !== user.Id);
  }

  /** Acik sekmeye degil tum sekmelere uygulanir. */
  async autoAssign(position: Position) {
    const other = position === 'master' ? 'observer' : 'master';
    this.autoAssigning = true;
    try {
      const result = await autoAssignShiftAvailable(this, this.workOrders.map((workOrder) => ({
        workOrderId: workOrder.Id,
        startDate: workOrder.ScheduledTime,
        pool: this.pools[workOrder.Id][position],
        selected: this.selections[workOrder.Id][position],
        otherPosition: this.selections[workOrder.Id][other],
      })));
      if (!result) return;
      result.selections.forEach((users, workOrderId) => { this.selections[workOrderId][position] = users; });
      result.availability.forEach((value, workOrderId) => { this.availability[workOrderId] = value; });
    } finally {
      this.autoAssigning = false;
    }
  }

  changeActiveTab(workOrder: any) {
    this.activeTab = workOrder;
    //@ts-ignore
    this.maintenancePlan = this.updateGetResponse.WorkOrders.find((item:any) => item.WorkOder.Id === this.activeTab.Id).WorkOder;
    //@ts-ignore
    this.startDate = moment(this.maintenancePlan.ScheduledTime).toDate();
    //@ts-ignore
    this.contractList = this.updateGetResponse.WorkOrders.find((item:any) => item.WorkOder.Id === this.activeTab.Id).Contracts.map(x=>(
      {
          Text:x.Name + `\n(${dateFormat.viewDateFormat(x.StartDate)} - ${dateFormat.viewDateFormat(x.EndDate)})`, 
          Value: x.Id, 
          StartDate: x.StartDate,
          EndDate: x.EndDate
      }
    ))
    this.vendorList = this.updateGetResponse.Vendors.map((x:any)=>({Name:<string>x.Text, Id:<number>x.Value}));
  }

  get StartDate(){
      if (this.startDate) {
        // @ts-ignore
        return moment(this.startDate).format(this.pickerDateTimeFormat);
      }
      return null;
  }
  set StartDate(val){
      if (val) {
        // @ts-ignore
        Vue.set(this, 'startDate', moment(val, this.pickerDateTimeFormat).toDate());
        this.maintenancePlan.ScheduledTime = dateFormat.postDateTimeFormat(<Date>this.startDate)
      } else {
        Vue.set(this, 'startDate', val);
        this.maintenancePlan.ScheduledTime = dateFormat.postDateTimeFormat(<Date>this.startDate)
      }
  }
  get selectedContract() {
      // @ts-ignore
      return this.selectGet('contractList', 'maintenancePlan.ContractId', 'Value', 'Text');
    }

    set selectedContract(newValue){
      this.contract = newValue;
      // @ts-ignore
      return this.selectSet('maintenancePlan.ContractId', 'Value', newValue);
    }


  async created() {
    const promises = [
      this.getMultipleMaintenancePlanUpdate()
    ];
    await Promise.all(promises);
    //@ts-ignore
    this.activeTab = this.selectedMaintenancePlans[0];
  }

  async getMultipleMaintenancePlanUpdate() {
    blockui.blockModal(this);
    this.loading = true;
    let idArray = this.selectedMaintenancePlans?.map((maintenancePlan) => maintenancePlan.Id);
    //@ts-ignore
    this.apiClient.maintenancePlan.getMultipleMaintenancePlanUpdate({workOrderIds:idArray?.toString()}).then((response) => {
        //@ts-ignore
        this.maintenanceTypeList = response.data.WorkOrderTypes;
        this.updateGetResponse = response.data;
        //@ts-ignore
        this.maintenancePlan = response.data.WorkOrders.find((item: any) => item.WorkOder.Id === this.activeTab.Id).WorkOder;
        //@ts-ignore
        this.startDate = moment(this.maintenancePlan.ScheduledTime).toDate();
        //@ts-ignore
        this.contractList = this.updateGetResponse.WorkOrders.find((item:any) => item.WorkOder.Id === this.activeTab.Id).Contracts.map(x=>(
          {
            Text:x.Name + `\n(${dateFormat.viewDateFormat(x.StartDate)} - ${dateFormat.viewDateFormat(x.EndDate)})`, 
            Value: x.Id, 
            StartDate: x.StartDate,
            EndDate: x.EndDate
          }
        ))
        this.vendorList = this.updateGetResponse.Vendors.map((x:any)=>({Name:<string>x.Text, Id:<number>x.Value}));

        // Her sekme kendi is emrinin listesi ve mevcut atamalariyla acilir.
        const pools: Record<number, Record<Position, any[]>> = {};
        const selections: Record<number, Record<Position, any[]>> = {};
        this.updateGetResponse.WorkOrders.forEach((item: any) => {
          const users = item.SuitableWorkUsers || [];
          pools[item.WorkOder.Id] = toUserPools(users);
          selections[item.WorkOder.Id] = {
            master: initialSelection(item.WorkOder.WorkOrderUsers, users, 'master'),
            observer: initialSelection(item.WorkOder.WorkOrderUsers, users, 'observer'),
          };
        });
        this.pools = pools;
        this.selections = selections;
        blockui.unBlockModal();
        this.loading = false;
    })
  }

  async onSubmit() {
    blockui.blockModal(this);
    blockui.unBlockModal();
  }

  async handleSave() {
    const anySelected = (position: Position, test: (user: any, workOrder: any) => boolean) =>
      this.workOrders.some((workOrder) => this.selections[workOrder.Id][position].some((user) => test(user, workOrder)));
    const shiftMismatch = (user: any, workOrder: any) =>
      isShiftMismatch(user, this.availability[workOrder.Id], workOrder.ScheduledTime);
    const overlap = (user: any) => !!user.IsHaveWorkOrder;

    const hasUserShiftWarning = anySelected('master', shiftMismatch);
    const hasUserOverlapWarning = anySelected('master', overlap);

    const hasObserverUserShiftWarning = anySelected('observer', shiftMismatch);
    const hasObserverOverlapWarning = anySelected('observer', overlap);

    if(hasUserShiftWarning || hasUserOverlapWarning || hasObserverUserShiftWarning || hasObserverOverlapWarning) {
      const alertTitle: string = "Atanmak istenen iş emirleri !!!";
      const alertMessage: string = 
        (hasUserShiftWarning || hasUserOverlapWarning ? "İşi Yapacak Personelin(Personellerin) " : "") +
        (hasUserShiftWarning ? "vardiyası ile eşleşmemektedir, " : "") +
        (hasUserOverlapWarning ? "diğer bir iş emriyle çakışan işleri bulunmaktadır. " : "") + "<br>" +
        (hasObserverUserShiftWarning || hasObserverOverlapWarning ? "Refakatçi Personelin(Personellerin) " : "") +
        (hasObserverUserShiftWarning ? "vardiyası ile eşleşmemektedir, " : "") + 
        (hasObserverOverlapWarning ? "diğer bir iş emriyle çakışan işleri bulunmaktadır." : "");

        // @ts-ignore
        let swalResponse = await swal.checkHtml(this, alertTitle, alertMessage)
        swalResponse.dismiss
        if (swalResponse !== undefined && swalResponse.dismiss !== undefined && swalResponse.dismiss === "cancel") { // if (!swalResponse.value) {
          return;
        }
    }

    // Personel atanmayan is emri engel degil: digerleri kaydedilir, bunlar Planlandi'da kalir.
    const unassigned = this.workOrders.filter((workOrder) => this.selections[workOrder.Id].master.length === 0);
    if (unassigned.length > 0) {
      const answer = await swal.check(this, this.translate('unassigned_work_orders_title'),
        this.translate('unassigned_work_orders_question').replace('{0}', unassigned.map((workOrder) => workOrder.Id).join(', ')));
      if (!answer.value) {
        return;
      }
    }

    let AssigneeUsers: any[] = [];
    blockui.blockModal(this);
    this.workOrders.forEach((workOrder) => {
      (['master', 'observer'] as Position[]).forEach((position) => this.selections[workOrder.Id][position].forEach((user) =>
        AssigneeUsers.push({ WorkOrderId: workOrder.Id, UserId: user.Id, UserPositionId: positionId(position) })));
    });

    let MaintenancePlans:any = [];
    this.workOrders.forEach((dataItem:any) => {
        MaintenancePlans.push({
            Id : dataItem.Id,
            Note : dataItem.Note,
            //@ts-ignore
            StartDate : dataItem.ScheduledTime,
            Duration : dataItem.Duration,
            MaintenanceTypeId : dataItem.OrderTypeId,
            VendorNotificationRemainingDay : dataItem.VendorNotificationRemainingDay,
            VendorId : dataItem.VendorId,
            ContractId: dataItem.ContractId
        })
    })

    console.log({AssigneeUsers,MaintenancePlans})

    // Freeze engel degil uyari: her planin gonderilecek tarih/suresi icin tek soru sorulur,
    // vazgecilirse dialog acik kalir. Tarih, kayittaki gibi sunucuda cozulur.
    if (!(await confirmFreezeConflicts(this, MaintenancePlans.map((plan: any) => ({ StartDate: plan.StartDate, Duration: plan.Duration }))))) {
      blockui.unBlockModal();
      return;
    }

    try {
      let response = await this.apiClient.maintenancePlan.updateMultipleMaintenance({AssigneeUsers,MaintenancePlans});
      if(response.data.IsSuccess){
        swal.success("Kaydedildi","Değişiklikler başarılı bir şekilde kaydedildi")
      }else{
        swal.error("Hata","Bir hata oluştu")
      }
      blockui.unBlockModal();
      this.saveSucceeded();
      this.close();
    } 
    catch (error) {
      swal.error("Hata","Bir hata oluştu")
      blockui.unBlockModal();
      this.saveSucceeded();
      this.close();
    }
  }
} 
